module.exports = __webpack_public_path__ + "static/media/icon-delete.f467f876.svg";